import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const FeaturedProducts = () => {
  return (
    <section className="py-16 md:py-24 bg-[#F5F5F5]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-8 md:mb-12"
        >
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#1A1A1A] mb-4">
            Nos produits phares
          </h2>
          <p className="text-base md:text-lg text-[#4A4A4A] max-w-3xl mx-auto px-4">
            Découvrez une large gamme de produits et dispositifs médicaux de haute qualité
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="text-center"
        >
          <Link
            to="/products"
            className="inline-block px-8 sm:px-12 py-3 sm:py-4 bg-[#E31B23] text-white rounded-lg font-medium text-base sm:text-lg hover:bg-[#C41820] transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
          >
            Voir tous les produits
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default FeaturedProducts;
